import BaseComponent from 'scripts/BaseComponent.js';
import FormValidate from 'scripts/helpers/formValidate.js';

export default class AccountRegisterForm extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      form: '.js-register-form',
      submit: '.js-register-submit',
    };

    this.dom = {
      $component: component,
      $form: this.$get(this.refs.form),
      $submit: this.$get(this.refs.submit),
    };

    this.state = {
      formValidate: new FormValidate(this.dom.$form),
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();
    dom.$submit.addEventListener('click', this.validate.bind(this));
  }

  validate(e) {
    const { state } = this;
    const hasErrors = state.formValidate.validate();

    if (hasErrors) {
      e.preventDefault();
    }
  }
}
